import { clientEnv } from '@/shared/config/env';
import { requestJson } from '@/shared/request/http-client';

/** 站点公开资料（游客可见）。supportUrl / telegramUrl 为空 = 后台未配置对应入口。 */
export interface SiteSocialAccount {
  accountType: string;
  displayName: string;
  iconUrl: string | null;
  jumpEnabled: boolean;
  targetUrl: string;
}

export interface SiteProfile {
  registerPointsEnabled?: boolean;
  registerPointsMinor?: number;
  siteId: string;
  socialAccounts?: SiteSocialAccount[];
  supportUrl: string | null;
  telegramUrl: string | null;
}

export const fetchSiteProfile = () =>
  requestJson<SiteProfile>(
    `/v1/app/site/profile?siteId=${encodeURIComponent(clientEnv.siteId)}`,
    { method: 'GET' },
  );
